export default "__VITE_ASSET__AMrU2LjV__"